/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';

import { UsageDialogBusinessService } from '../resources/usage-dialog-business.service';
import { UsageDialogComponent } from './usage-dialog.component';

export const usageDialogRoute = createDialogRoute({
  component: UsageDialogComponent,
  init: UsageDialogBusinessService,
});
